import {
  isMobile as _isMobile,
  isAndroid as _isAndroid,
  isIOS as _isIOS,
  isFirefox as _isFirefox,
  isOpera as _isOpera,
  browserVersion as _browserVersion,
} from 'mobile-device-detect';

const ua = navigator.userAgent || navigator.vendor;

export const isMobile = _isMobile;
export const isIOS = _isIOS;
export const isAndroid = _isAndroid;
export const isFirefox = _isFirefox;
export const isOpera = _isOpera;
export const browserVersion = _browserVersion;

export const isFacebookInApp = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
export const isMessenger = ua.indexOf('MessengerForiOS') > -1 || ua.indexOf('MESSENGER') > -1;
export const isInstagramInApp = ua.indexOf('Instagram') > -1;
export const isWhatsApp = ua.indexOf('WhatsApp') > -1;
export const isDisallowedByGoogle = isFacebookInApp || isMessenger || isInstagramInApp || isWhatsApp;
export const isTwitterInApp = ua.indexOf('TwitterAndroid') > -1;
export const isLinkedInInApp = ua.indexOf('LinkedInApp') > -1;
export const isPWA = window.hasOwnProperty('matchMedia') && window?.matchMedia('(display-mode: standalone)').matches;
export const isInAppBrowser = isFacebookInApp || isInstagramInApp || isTwitterInApp || isLinkedInInApp;
